import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .proj-section {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .proj-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  .proj-header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .proj-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: projFadeUp 0.7s ease 0.1s both;
  }
  .proj-label::before, .proj-label::after { content: ''; width: 50px; height: 1px; }
  .proj-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .proj-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .proj-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: projFadeUp 0.7s ease 0.2s both;
  }

  .proj-filters {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 3rem;
    flex-wrap: wrap;
    opacity: 0;
    animation: projFadeUp 0.7s ease 0.3s both;
  }

  .proj-filter-btn {
    padding: 0.5rem 1.5rem;
    background: transparent;
    color: #4a7a9b;
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: 1px solid rgba(0,170,255,0.15);
    cursor: pointer;
    clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
    transition: all 0.3s;
  }

  .proj-filter-btn:hover { color: #00aaff; border-color: rgba(0,170,255,0.4); }
  .proj-filter-btn.active {
    background: rgba(0,170,255,0.1);
    color: #00aaff;
    border-color: rgba(0,170,255,0.5);
    box-shadow: 0 0 15px rgba(0,170,255,0.15);
  }

  .proj-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1.5rem;
    opacity: 0;
    animation: projFadeUp 0.7s ease 0.4s both;
  }

  .proj-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    position: relative;
    transition: border-color 0.3s, box-shadow 0.3s, transform 0.3s;
    display: flex;
    flex-direction: column;
  }

  .proj-card:hover {
    border-color: rgba(0,170,255,0.35);
    box-shadow: 0 0 30px rgba(0,170,255,0.1);
    transform: translateY(-4px);
  }

  .proj-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .proj-card-inner {
    padding: 1.8rem;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .proj-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.8rem;
  }

  .proj-card-cat {
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #ffaa33;
    letter-spacing: 2px;
    text-transform: uppercase;
    background: rgba(255,140,0,0.08);
    border: 1px solid rgba(255,140,0,0.2);
    border-radius: 3px;
    padding: 0.2rem 0.6rem;
  }

  .proj-card-num {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: rgba(0,170,255,0.3);
    letter-spacing: 1px;
  }

  .proj-course-badge {
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #00aaff;
    letter-spacing: 1px;
    background: rgba(0,170,255,0.07);
    border: 1px solid rgba(0,170,255,0.2);
    border-radius: 3px;
    padding: 0.15rem 0.5rem;
    margin-bottom: 0.6rem;
    display: inline-block;
  }

  .proj-card-title {
    font-family: 'Orbitron', monospace;
    font-size: 0.85rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.8rem;
    line-height: 1.3;
  }

  .proj-card-desc {
    font-size: 0.88rem;
    line-height: 1.75;
    color: rgba(232,244,255,0.5);
    margin-bottom: 1.2rem;
    flex: 1;
  }

  .proj-divider {
    height: 1px;
    background: linear-gradient(to right, rgba(0,170,255,0.2), transparent);
    margin-bottom: 1rem;
  }

  .proj-role-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #00aaff;
    letter-spacing: 2px;
    margin-bottom: 0.4rem;
  }

  .proj-role-text {
    font-size: 0.85rem;
    color: rgba(232,244,255,0.5);
    margin-bottom: 1.2rem;
    line-height: 1.6;
  }

  .proj-tech-stack {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-bottom: 1.5rem;
  }

  .proj-tech-tag {
    background: rgba(0,170,255,0.06);
    border: 1px solid rgba(0,170,255,0.18);
    border-radius: 3px;
    padding: 0.2rem 0.6rem;
    font-size: 0.75rem;
    color: rgba(232,244,255,0.55);
    transition: all 0.3s;
  }

  .proj-tech-tag:hover {
    border-color: rgba(0,170,255,0.45);
    color: #e8f4ff;
  }

  .proj-links {
    display: flex;
    gap: 0.8rem;
    margin-top: auto;
  }

  .proj-link-btn {
    padding: 0.45rem 1.2rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-decoration: none;
    border: 1px solid rgba(0,170,255,0.3);
    color: #00aaff;
    background: transparent;
    clip-path: polygon(6px 0%, 100% 0%, calc(100% - 6px) 100%, 0% 100%);
    transition: all 0.3s;
    cursor: pointer;
  }

  .proj-link-btn:hover {
    background: rgba(0,170,255,0.1);
    box-shadow: 0 0 12px rgba(0,170,255,0.25);
  }

  @keyframes projFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 900px) {
    .proj-section { padding: 100px 2rem 60px; }
    .proj-grid { grid-template-columns: 1fr; }
  }
`;

const PROJECTS_DATA = [
  {
    id: 0,
    course: "CPE-CP1",
    title: "C Language Calculator",
    description: "A functional calculator program developed in C language, supporting basic arithmetic operations with a clean command-line interface.",
    tech: ["C Language", "CLI"],
    role: "Sole Developer — designed and implemented all arithmetic logic and UI flow.",
    github: "#",
    demo: "#",
    category: "Software",
  },
  {
    id: 1,
    course: "PHYSICS FOR ENGINEERS",
    title: "Angle Projector Prototype",
    description: "A physical prototype that tosses a ball at different angles to demonstrate projectile motion principles in engineering physics.",
    tech: ["Prototyping", "Physics", "Mechanics"],
    role: "Designer & Builder — built the mechanism and conducted angle variation experiments.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 2,
    course: "CPE-CP2",
    title: "YOLO-Based Object Detection & Musical Note Mapping System",
    description: "An AI-powered system using YOLO for real-time object detection, mapping detected objects to musical notes for an interactive audio-visual experience.",
    tech: ["Python", "YOLO", "OpenCV", "AI/ML", "Audio Processing"],
    role: "AI Developer — implemented YOLO detection pipeline and musical note mapping logic.",
    github: "#",
    demo: "#",
    category: "AI/ML",
  },
  {
    id: 3,
    course: "CPE-MAT",
    title: "Real-Time Chord Synthesis & Frequency Analysis",
    description: "A GUI application that performs real-time chord synthesis and frequency analysis using Fourier Transform, visualizing audio signals and harmonics interactively.",
    tech: ["Python", "Fourier Transform", "GUI", "DSP", "Matplotlib"],
    role: "Developer — built the GUI, implemented FFT analysis and real-time chord synthesis.",
    github: "#",
    demo: "#",
    category: "Software",
  },
  {
    id: 4,
    course: "CPE-OOP",
    title: "PIKTYUR-PIKTYUR Photobooth",
    description: "A Python-based photobooth application with SQL database backend, allowing users to capture, save, and manage photos with an interactive UI.",
    tech: ["Python", "SQL", "OOP", "GUI", "Database"],
    role: "Full Developer — designed the OOP architecture, database schema, and UI.",
    github: "#",
    demo: "#",
    category: "Software",
  },
  {
    id: 5,
    course: "CPE2 LAW",
    title: "Computer Ethics Infomercial",
    description: "An engaging group infomercial about a selected Commandment of Computer Ethics, raising awareness on ethical responsibilities of computer users.",
    tech: ["Video Production", "Research", "Teamwork"],
    role: "Group Member — contributed to script writing, research, and production.",
    github: "#",
    demo: "#",
    category: "Other",
  },
  {
    id: 6,
    course: "CPE-DMA",
    title: "Grey Code to Boolean Algebra & K-Map Simplifier",
    description: "A Python-based tool that converts standard Grey Code to Boolean Algebra expressions and simplifies them using Karnaugh Map reduction.",
    tech: ["Python", "Boolean Algebra", "K-Map", "Digital Math"],
    role: "Sole Developer — designed the conversion logic and simplification algorithm.",
    github: "#",
    demo: "#",
    category: "Software",
  },
  {
    id: 7,
    course: "CPE-DES",
    title: "Two-Digit Decimal Counter PCB Design",
    description: "Circuit design and PCB layout of a two-digit decimal counter circuit created using Altium Designer, ready for fabrication.",
    tech: ["Altium Designer", "PCB Layout", "Circuit Design", "Digital Electronics"],
    role: "Circuit Designer — designed schematic, routed PCB, and verified design rules.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 8,
    course: "CPE-LOG",
    title: "7-Segment Display with DIP Switch (0 to F)",
    description: "A hardware project where a 7-segment display changes its output from 0 to F based on different DIP switch combinations, demonstrating combinational logic.",
    tech: ["Digital Logic", "7-Segment Display", "DIP Switch", "Hardware"],
    role: "Hardware Developer — wired the circuit and verified all 16 display states.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 9,
    course: "CPE-MIC1",
    title: "Water Tank Monitoring & Pump Control System",
    description: "A sequential RTL design system that monitors water tank levels and controls a pump with a pH safety override, ensuring safe and automated water management.",
    tech: ["RTL Design", "Sequential Logic", "Sensors", "Embedded Systems"],
    role: "RTL Designer — implemented the sequential logic for monitoring and safety override.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 10,
    course: "ECE-FCS / CPE-MIC",
    title: "Glove-Controlled Robot Arm",
    description: "A robot controlled via a mobile app with 2 ESP32 modules — one as a camera module for POV streaming, and the other controlling chassis motors and a flex-sensor glove for robotic claw operation to grab objects.",
    tech: ["ESP32", "Arduino", "C++", "IoT", "Flex Sensors", "Mobile App", "Camera Module"],
    role: "Hardware & Firmware Developer — designed circuit, programmed ESP32 modules, integrated flex sensors and camera streaming.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 11,
    course: "CPE-MIC2",
    title: "Mealy Machine-Based Vending Machine Controller",
    description: "A Verilog-based vending machine controller implemented as a Mealy Machine in Quartus II, verified through FPGA simulation on an Altera Cyclone V board. Handles cancellation, overpayment, exact payment, and invalid transactions.",
    tech: ["Verilog", "Quartus II", "FPGA", "Mealy Machine", "Altera Cyclone V"],
    role: "RTL Designer — designed Mealy Machine FSM and verified all transaction scenarios on FPGA.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 12,
    course: "CPE-MIC2",
    title: "FPGA-Based Pico Park: 4-Player Multiplayer Game",
    description: "A 4-player multiplayer game inspired by Pico Park, implemented on an Altera DE0-CV FPGA board, demonstrating real-time game logic and hardware-level programming.",
    tech: ["Verilog", "FPGA", "Altera DE0-CV", "Game Logic", "Hardware Design"],
    role: "FPGA Developer — designed game logic and implemented real-time multiplayer interaction.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 13,
    course: "CPE-ES",
    title: "Secure Smart Parking System",
    description: "A smart parking system simulated in Wokwi with automated entry/exit control, slot monitoring, and security features for efficient parking management.",
    tech: ["Wokwi", "ESP32", "Embedded Systems", "IoT", "Sensors"],
    role: "Systems Developer — designed the parking logic, sensor integration, and security override.",
    github: "#",
    demo: "#",
    category: "Embedded",
  },
  {
    id: 14,
    course: "CPE-DS",
    title: "Professional Portfolio Website",
    description: "A professional personal portfolio built with ReactJS featuring a cyberpunk aesthetic, deployed via Cloudflare Pages with EmailJS contact integration.",
    tech: ["ReactJS", "JavaScript", "CSS", "Cloudflare", "EmailJS"],
    role: "Full-stack Frontend Developer — designed UI/UX and developed all components.",
    github: "#",
    demo: "https://professionalportfolio-2026.pages.dev",
    category: "Web",
  },
  {
    id: 15,
    course: "CPE-DS",
    title: "CHICK UP Restaurant Website",
    description: "A restaurant website for 'CHICK UP' built with HTML, CSS, JavaScript frontend and React, with a Python Flask backend deployed to Render.",
    tech: ["HTML", "CSS", "JavaScript", "ReactJS", "Python", "Flask", "Render"],
    role: "Full-stack Developer — built frontend UI and Python Flask backend, handled deployment.",
    github: "#",
    demo: "#",
    category: "Web",
  },
];

const CATEGORIES = ["All", "Web", "Embedded", "AI/ML", "Software", "Other"];

export default function Projects() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered =
    activeCategory === "All"
      ? PROJECTS_DATA
      : PROJECTS_DATA.filter((p) => p.category === activeCategory);

  return (
    <section className="proj-section" id="projects">
      <style>{styles}</style>
      <div className="proj-container">

        <div className="proj-header">
          <p className="proj-label">What I've Built</p>
          <h2 className="proj-title">Projects</h2>
        </div>

        <div className="proj-filters">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              className={`proj-filter-btn ${activeCategory === cat ? "active" : ""}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="proj-grid">
          {filtered.map((project, i) => (
            <div className="proj-card" key={project.id}>
              <div className="proj-card-inner">
                <div className="proj-card-top">
                  <span className="proj-card-cat">{project.category}</span>
                  <span className="proj-card-num">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>

                <span className="proj-course-badge">{project.course}</span>
                <h3 className="proj-card-title">{project.title}</h3>
                <p className="proj-card-desc">{project.description}</p>

                <div className="proj-divider" />

                <p className="proj-role-label">// Role</p>
                <p className="proj-role-text">{project.role}</p>

                <div className="proj-tech-stack">
                  {project.tech.map((t, j) => (
                    <span className="proj-tech-tag" key={j}>{t}</span>
                  ))}
                </div>

                <div className="proj-links">
                  <a href={project.github} className="proj-link-btn">GitHub</a>
                  {project.demo !== "#" && (
                    <a href={project.demo} target="_blank" rel="noreferrer" className="proj-link-btn">Demo</a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}